import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;  
  margin-bottom: 16px;
`;

export const Button = styled.button`  
  width: 97px;
  height: 26px;  
  margin: 4px;  
  border-radius: 4px;  
  border-width: 1px;
  border-color: #FFFFFF;
  border-style: solid; 
  flex: 1;  
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ButtonText = styled.div`  
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #FFFFFF;
`;
